export const css = {
	button: 'm7jVvxIs',
	pressed: '_37fl_I7Q',
	' _key': 'apic-theme/apic/base-widgets/speed-dial'
};

export default css;
